<template>
  <div>
    <el-drawer @reload="$reloadHandle" title="投诉处理" size="40%" :before-close="handleClose" :visible.sync="visiable"
      direction="rtl" append-to-body custom-class="demo-drawer" ref="drawer" class="details2">

      <div class="demo-drawer__content">


        <template>
          <div>
            <div class="detail-wrap">
              <el-form ref="editForm" :model="formData">
                <div class="d-header">
                  <div class="" style="padding: 5px;border-bottom: 1px solid #ededed">
                    <i class="el-icon-info" style="color: #00c4b3;" />
                    <!-- {{ dataId ? '查看' : '新增' }}工单 -->
                    工单号：<span style="font-weight: 600;color: #2196f3;margin-right: 5px;">{{
                      formData.orderNo
                    }}</span>
                    <!-- 服务类型 -->
                    <span class="information">{{ formData.serverTypeName }}</span>

                    <!-- 工单状态 -->
                    <span class="information" v-if="formData.stat == 1">登记</span>
                    <span class="information" v-else-if="formData.stat == 2">发布</span>
                    <span class="information" v-else-if="formData.stat == 5">已派网点</span>
                    <span class="information" v-else-if="formData.stat == 6">网点已接单</span>
                    <span class="information" v-else-if="formData.stat == 9">已派师傅</span>
                    <span class="information" v-else-if="formData.stat == 10">师傅已接单</span>
                    <span class="information" v-else-if="formData.stat == 11">已预约</span>
                    <span class="information" v-else-if="formData.stat == 13">已出发</span>
                    <span class="information" v-else-if="formData.stat == 17">已上门</span>
                    <span class="information" v-else-if="formData.stat == 20">完工暂存</span>
                    <span class="information" v-else-if="formData.stat == 30">寄修待确认</span>
                    <span class="information" v-else-if="formData.stat == 31">待寄件</span>
                    <span class="information" v-else-if="formData.stat == 32">已寄待签收</span>
                    <span class="information" v-else-if="formData.stat == 36">待维修</span>
                    <span class="information" v-else-if="formData.stat == 37">修好待寄出</span>
                    <span class="information" v-else-if="formData.stat == 38">客户待签收</span>
                    <span class="information" v-else-if="formData.stat == 40">退换待确认</span>
                    <span class="information" v-else-if="formData.stat == 41">旧机待退回</span>
                    <span class="information" v-else-if="formData.stat == 42">旧机待签收</span>
                    <span class="information" v-else-if="formData.stat == 43">旧机已签收</span>
                    <span class="information" v-else-if="formData.stat == 44">新机待寄出</span>
                    <span class="information" v-else-if="formData.stat == 45">新机已寄出</span>
                    <span class="information" v-else-if="formData.stat == 47">新机待签收</span>
                    <span class="information" v-else-if="formData.stat == 48">新机已签收</span>
                    <span class="information" v-else-if="formData.stat == 49">退换被驳回</span>
                    <span class="information" v-else-if="formData.stat == 61">已完工</span>
                    <span class="information" v-else-if="formData.stat == 62">网点确认完工</span>
                    <span class="information" v-else-if="formData.stat == 63">中心完工审核</span>
                    <span class="information" v-else-if="formData.stat == 64">总部完工审核</span>
                    <span class="information" v-else-if="formData.stat == 91">待结算</span>
                    <span class="information" v-else-if="formData.stat == 92">结算驳回</span>
                    <span class="information" v-else-if="formData.stat == 93">结算中止</span>
                    <span class="information" v-else-if="formData.stat == 94">已结算</span>
                    <span class="information" v-else-if="formData.stat == 97">申请关闭</span>
                    <span class="information" v-else-if="formData.stat == 98">挂起</span>
                    <span class="information" v-else-if="formData.stat == 99">取消</span>
                    <span class="information" v-else></span>
                  </div>
                </div>

                <el-form-item label="处理结果" :rules="{ required: true }"
                  style="margin-top: 8px; display: flex;align-items: center;">
                  <el-radio v-model="formData.result" :label="'投诉跟进'">投诉跟进</el-radio>
                  <el-radio v-model="formData.result" :label="'待协调'">待协调</el-radio>
                  <!--                  <el-radio v-model="formData.result" :label="'转线处理'">转线处理</el-radio>-->
                  <el-radio v-model="formData.result" :label="'结束'">结束</el-radio>
                  <el-radio v-model="formData.result" :label="'取消'">取消</el-radio>
                  <el-radio v-model="formData.result" :label="'驳回'">驳回</el-radio>
                  <el-radio v-model="formData.result" :label="'转线方案执行'">转线方案执行</el-radio>
                </el-form-item>

                <el-form-item label="处理备注" :rules="{ required: true }" style="   ">
                  <el-input type="textarea" :autosize="{ minRows: 4, maxRows: 8 }" v-model="formData.remark"
                    autocomplete="off" style="width:28vw;display: flex;"></el-input>
                </el-form-item>
                <div style="font-size: 12px;
    font-weight: 400;
    width: 100px;
    margin-left: 28px;margin-top: 10px;" v-if="formData.result == '转线处理'">转线督办：</div>

                <div v-if="formData.result == '转线处理'" style="display: flex;margin-top: 10px;display:flex">
                  <el-form-item label="督办人" style="display:flex">
                    <handle-pop-search :handle-id.sync="formData.handleId" :handle-name.sync="formData.handleName"
                      style="width: 10vw;" />
                  </el-form-item>

                  <el-form-item label="督办时间" style="display:flex">
                    <el-date-picker v-model="formData.handleTime" :picker-options="{
                      disabledDate: time => {
                        return time < new Date()
                      }
                    }" style="width: 10vw;" type="datetime" placeholder="选择日期时间" align="right"
                      default-time="12:00:00" value-format="yyyy-MM-dd HH:mm:ss">
                    </el-date-picker>
                  </el-form-item>
                </div>


                <el-form-item v-if="formData.result == '转线处理'" label="督办事项" style="display:flex">
                  <dict-select dict-type="督办事项" :dict-item-id.sync="formData.handleMatter"
                    :dict-item-name.sync="formData.handleMatterName" style="width: 10vw;" />
                </el-form-item>



                <div style="font-size: 12px;
    font-weight: 400;
    width: 300px;
    margin-left: 28px;margin-top: 10px;margin-bottom: 30px;" v-if="formData.result == '结束'">以下为责任与考核,请填写：</div>

                <el-form-item v-if="formData.result == '结束'" :rules="{ required: true }" label="责任判定" style="display:flex">
                  <dict-select dict-type="责任判定" :dict-item-id.sync="formData.dutyJudge"
                    :dict-item-name.sync="formData.dutyJudgeName" style="width: 10vw;"/>
                </el-form-item>

                <el-form-item v-if="formData.result == '结束'" :rules="{ required: true }" label="责任细分" style="display:flex">
                  <!--                  <dict-select dict-type="责任细分"-->
                  <!--                               :dict-item-id.sync="formData.dutyJudgeSub"-->
                  <!--                               :dict-item-name.sync="formData.dutyJudgeSubName"-->
                  <!--                               style="width: 10vw;"-->
                  <!--                  />-->
                  <el-select v-model="formData.dutyJudgeSub" placeholder="" style="width: 10vw!important;">
                    <el-option v-for="item in dutyJudgeSubList" :key="item.id" :label="item.label" :value="item.id" />
                  </el-select>
                </el-form-item>

                <el-form-item v-if="formData.result == '结束'" label="处理方式" style="display:flex">
                  <dict-select dict-type="处理方式" :dict-item-id.sync="formData.handleModel"
                    :dict-item-name.sync="formData.handleModelName" style="width: 10vw;" />
                </el-form-item>

                <div v-if="formData.result === '取消'">
                  <el-form-item label="取消原因">
                    <el-select v-model="formData.returnId" style="width: 8vw;" ref="returnId" clearable filterable>
                      <el-option v-for="item in returnData" :key="item.id" :label="item.returnName" :value="item.id">
                      </el-option>
                    </el-select>
                  </el-form-item>
                </div>

                <el-form-item v-if="formData.result == '结束'" label="启动考核" style="display:flex">
                  <checkSubjectSearch :check-subject-id.sync="formData.checkSubjectId" style="width: 10vw;"
                    :check-subject-name.sync="formData.checkSubjectName"  :disabled="isAutoCheck"/>
                </el-form-item>

                <el-form-item v-if="formData.result == '结束'" label="处理方案" :rules="{ required: true }" style="   ">
                  <el-input type="textarea" :autosize="{ minRows: 4, maxRows: 8 }" v-model="formData.handlePlan"
                    autocomplete="off" style="width:28vw;display: flex;"></el-input>
                </el-form-item>


                <el-form-item label="图片凭证" style="   ">
                  <div class="form_picture">
                    <photo-upload :photo-url.sync="formData.pic1" />
                  </div>
                </el-form-item>
                <el-form-item label="文件凭证" style="   ">
                  <div class="form_picture">
                    <text-upload :photo-url.sync="formData.documentBook" />
                  </div>
                </el-form-item>
                <!-- <el-form-item label="录音/视频"  style="   ">
                  <div class="form_picture">
                    <video-upload :photo-url.sync="formData.videoUrl"/>

                  </div>
                </el-form-item> -->
                <el-form-item label="录音/视频" style="   ">
                  <div class="form_picture" style="display: flex;">
                    <div @click="showVideo = true" class="videoAdd"> <i class="el-icon-plus"></i></div>
                    <!-- 多个视屏文件 -->
                    <div style="display: flex; flex-wrap: wrap;">
                      <div class="videoP" v-for="item in formData.videoUrl" :key="item.url">

                        <div style="width:40%;    position: relative;" class="videoImg">
                          <el-image style="width: 30px; height: 35px" :src="require('@/views/dialogCommon/video.jpg')"
                            fit="fit"></el-image>
                          <div @click="openVideo(item.url)" class="imgY"><i class="el-icon-video-play"></i></div>
                        </div>

                        <div
                          style="width:50%;display:flex;    flex-direction: column;justify-content: space-between;align-items: flex-end;">
                          <span style="    width: 70%;
    height: 70%;
    overflow: hidden;">{{ item.name }}</span>
                          <div @click="handleDownload(item.name, item.url)">
                            <el-tooltip class="item" effect="dark" content="下载" placement="top">

                              <i class="el-icon-download"></i>
                            </el-tooltip>
                          </div>
                        </div>

                      </div>


                    </div>





                  </div>
                </el-form-item>
              </el-form>
            </div>
          </div>
        </template>
        <div class="demo-drawer__footer" style="position: absolute;
    bottom: 5px;
    right: 5px;">
          <el-button @click="cancelForm">取 消</el-button>
          <el-button type="primary" @click="commit">
            确 定
          </el-button>
        </div>
      </div>
    </el-drawer>
    <!-- 视频上传 -->
    <videoDialog v-if="showVideo" @commitVideo="commitVideo" :visiable.sync="showVideo" multi="true" />
  </div>
</template>
<script>
import api from "@/api/projectApi";
import DictSelect from "@/components/formItem/dictSelect.vue";
import CheckSubjectSearch from "@/components/formItem/checkSubjectSearch2.vue";
import HandlePopSearch from "@/components/formItem/handlePopSearch.vue";
import checkSubjectSearch from "@/components/formItem/checkSubjectSearch2.vue";
import request from "@/router/axios";
import PhotoUpload from "@/components/formItem/photoUploadMore.vue";
import textUpload from "@/components/formItem/textUploadMore.vue";
import videoUpload from "@/components/formItem/videoUploadMore.vue";

import videoDialog from '@/views/dialogCommon/video2Dialog.vue'


export default {
  name: 'orderComplaintHandlingDialog',
  components: {
    HandlePopSearch, CheckSubjectSearch, DictSelect, checkSubjectSearch, PhotoUpload,
    textUpload, videoUpload, videoDialog,
  },
  props: ['multi', 'rowData', 'visiable'],
  created() {
    this.$objCopy(this.rowData, this.formData)
    this.formData.remark = null
    this.getData();
    this.getReturnType();
  },
  data() {
    return {
      showVideo: false,
      isAutoCheck: false,
      dutyJudgeSubList: [],
      formData: {
        result: null,
        remark: null,
        handleId: null,  //督办人ID
        handleName: null,  //督办人名称
        handleTime: null,
        handleMatter: null,
        handleMatterName: null,

        dutyJudge: 0,
        dutyJudgeName: null,
        dutyJudgeSub: null,
        dutyJudgeSubName: null,
        handleModel: null,
        handleModelName: null,
        checkSubjectId: null,
        checkSubjectName: null,
        handlePlan: '',
        returnId: null,
        returnName: null,

        id: null,
        orderNo: null,
        serverTypeName: null,
        stat: null,
        pic1: [],
        pic2: '',
        pic3: '',
        videoUrl: [],
        // 文件
        documentBook: [{ url: '', name: '' }],
      },
    }
  },
  watch: {
    'formData.result': {
      handler(n) {
        if (n !== '转线处理') {
          this.formData.handleName = null
          this.formData.handleId = null
          this.formData.handleMatter = null
          this.formData.handleTime = null
          this.formData.handleMatterName = null
        }
      }
    },
    'formData.dutyJudge': function (newValue, oldValue) {
      this.getdutyJudgeSub(newValue)
    },
    'formData.dutyJudgeSub': function (newValue, oldValue) {
      this.handleDutyJudgeSubChange(newValue)
    },
    'formData.dutyJudgeName': function (newValue, oldValue) {
      this.handleDutyJudgeChange(newValue)
    }
  },
  methods: {
    openVideo(url){
      var page = window.open();

var html="<body style='background:black'><div style='width:70%;margin:auto;'><video controls width='100%' autoplay src='"+url+ "'></video> </div></body>"

page.document.write(html);

      // window.open(this.formData.vedioUrl, '_blank')
    },
    // 视频下载
    handleDownload(Vname,Vurl) {
      this.$mask.open()

      console.log(Vname,Vurl, "视频下载");
      // let url=file.type
      let url = Vurl
      let name = Vname

      const x = new XMLHttpRequest()
      x.open('GET', url, true)
      x.responseType = 'blob'
      x.onload = function () {
        const url = window.URL.createObjectURL(x.response)
        const a = document.createElement('a')
        a.href = url
        a.download = name
        a.click()
      }
      x.send()
      this.$mask.close()


      // window.open(url,'_blank');
    },
    // 视频上传文件
    commitVideo(data) {
      console.log('选中的多视频数据', data)
      let combinedArray = [...this.formData.videoUrl, ...data];
console.log(combinedArray);
      this.formData.videoUrl=combinedArray
      console.log( this.formData.videoUrl,"4545454");
      // this.formData.vedioName=data.vedioName
      // this.formData.vedioUrl=data.vedioUrl





      // console.log('修改后的数据', this.formData)
    },
    handleDutyJudgeChange(e) {
      this.formData.checkSubjectId = null;
      this.formData.checkSubjectName = null;
      this.formData.dutyJudgeSub = null;
      this.formData.handleModel = null;
      this.formData.handleModelName = null;
      this.isAutoCheck = false;
    },
    handleDutyJudgeSubChange(e) {
      let checkName = '';
      let selectedLabel = this.dutyJudgeSubList.find(item => item.id === e).label;
      if (this.formData.dutyJudgeName === '服务商责任') {
        if(selectedLabel=='言语诋毁品牌，教唆用户退换货' || selectedLabel=='损害华帝形象，唆使退换货'){
          checkName = '言语诋毁品牌，教唆用户退换货';
        }else if(selectedLabel=='服务不及时'){
          checkName = '服务不及时';
        }else if(selectedLabel=='技能不熟练'){
          checkName = '技能不熟练';
        }else if(selectedLabel=='配件不到位'){
          checkName = '配件不到位';
        }else if(selectedLabel=='收费不合理'){
          checkName = '收费不合理';
        }else if(selectedLabel=='拒绝服务'){
          checkName = '拒绝服务';
        }else if(selectedLabel=='服务态度恶劣'){
          checkName = '服务态度恶劣';
        }else if(selectedLabel=='作业不规范'){
          checkName = '作业不规范';
        }else if(selectedLabel=='退换货不及时'){
          checkName = '退换货不及时';
        }else if(selectedLabel=='服务质量或服务不及时导致政府部门转来投诉'){
          checkName = '因服务质量导致消费者在市场监督部门投诉';
        }else if(selectedLabel=='重大质量事故处理不当导致曝光'){
          checkName = '因服务质量导致消费在媒体、社交平台、网络平台曝光';
        }else if(selectedLabel=='拒绝执行总部政策'){
          checkName = '拒执行政策/指令/通知';
        }else if(selectedLabel=='因服务质量导致消费在媒体、社交平台、网络平台曝光'){
          checkName = '因服务质量导致消费在媒体、社交平台、网络平台曝光';
        }else if(selectedLabel=='因服务商质量导致退换货'){
          checkName = '因服务过失导致消费者退换货';
        }else if(selectedLabel=='承诺不兑现'){
          checkName = '承诺不兑现';
        }else if(selectedLabel=='服务形象照不规范'){
          checkName = '服务形象照不规范';
        }else if(selectedLabel=='上门设计单录入不规范'){
          checkName = '上门设计单录入不规范';
        }else if(selectedLabel=='因服务质量导致消费者在市场监督部门投诉'){
          checkName = '因服务质量导致消费者在市场监督部门投诉';
        }else if(selectedLabel=='因服务质量导致消费者在黑猫投诉'){
          checkName = '因服务质量导致消费者在黑猫投诉';
        }else if(selectedLabel=='因服务质量导致消费者在中国消费品质量网投诉'){
          checkName = '因服务质量导致消费者在中国消费品质量网投诉';
        }else if(selectedLabel=='承诺不兑现'){
          checkName = '承诺不兑现';
        }else if(selectedLabel=='服务形象照不规范'){
          checkName = '服务形象照不规范';
        }else if(selectedLabel=='上门设计单录入不规范'){
          checkName = '上门设计单录入不规范';
        }else if(selectedLabel=='因服务过失导致消费者退换货 '){
          checkName = '因服务过失导致消费者退换货 ';
        }
      }else if(this.formData.dutyJudgeName === '授权商责任'){
        if(selectedLabel=='言语诋毁品牌，教唆用户退换货' || selectedLabel=='损害华帝形象，唆使退换货'){
          checkName = '言语诋毁品牌，教唆用户退换货';
        }else if(selectedLabel=='服务不及时'){
          checkName = '服务不及时';
        }else if(selectedLabel=='技能不熟练'){
          checkName = '技能不熟练';
        }else if(selectedLabel=='配件不到位'){
          checkName = '配件不到位';
        }else if(selectedLabel=='收费不合理'){
          checkName = '收费不合理';
        }else if(selectedLabel=='拒绝服务'){
          checkName = '拒绝服务';
        }else if(selectedLabel=='服务态度恶劣'){
          checkName = '服务态度恶劣';
        }else if(selectedLabel=='作业不规范'){
          checkName = '作业不规范';
        }else if(selectedLabel=='退换货不及时'){
          checkName = '退换货不及时';
        }else if(selectedLabel=='服务质量或服务不及时导致政府部门转来投诉'){
          checkName = '因服务质量导致消费者在市场监督部门投诉';
        }else if(selectedLabel=='重大质量事故处理不当导致曝光'){
          checkName = '因服务质量导致消费在媒体、社交平台、网络平台曝光';
        }else if(selectedLabel=='拒绝执行总部政策'){
          checkName = '拒执行政策/指令/通知';
        }else if(selectedLabel=='因服务质量导致消费在媒体、社交平台、网络平台曝光'){
          checkName = '因服务质量导致消费在媒体、社交平台、网络平台曝光';
        }else if(selectedLabel=='因服务商质量导致退换货'){
          checkName = '因服务过失导致消费者退换货';
        }else if(selectedLabel=='承诺不兑现'){
          checkName = '承诺不兑现';
        }else if(selectedLabel=='服务形象照不规范'){
          checkName = '服务形象照不规范';
        }else if(selectedLabel=='上门设计单录入不规范'){
          checkName = '上门设计单录入不规范';
        }else if(selectedLabel=='因服务质量导致消费者在市场监督部门投诉'){
          checkName = '因服务质量导致消费者在市场监督部门投诉';
        }else if(selectedLabel=='因服务质量导致消费者在黑猫投诉'){
          checkName = '因服务质量导致消费者在黑猫投诉';
        }else if(selectedLabel=='因服务质量导致消费者在中国消费品质量网投诉'){
          checkName = '因服务质量导致消费者在中国消费品质量网投诉';
        }else if(selectedLabel=='承诺不兑现'){
          checkName = '承诺不兑现';
        }else if(selectedLabel=='服务形象照不规范'){
          checkName = '服务形象照不规范';
        }else if(selectedLabel=='上门设计单录入不规范'){
          checkName = '上门设计单录入不规范';
        }else if(selectedLabel=='因服务过失导致消费者退换货 '){
          checkName = '因服务过失导致消费者退换货 ';
        }
      }
      if(checkName!=null&&checkName!='') {
        request({
          url: api.basCheckSubject.getByCheckNameUrl,
          method: 'post',
          data: {
            name: checkName
          },
          isLoading: true,
          modalStrictly: true,
        }).then(response => {
          if (response.data != null && response.data.data != null && response.data.data.name != null) {
            this.formData.checkSubjectId = response.data.data.id;
            this.formData.checkSubjectName = response.data.data.name;
            this.isAutoCheck = true;
          } else {
            this.formData.checkSubjectId = null;
            this.formData.checkSubjectName = null;
            this.isAutoCheck = false;
          }
        })
      }
    },
    getReturnType() {
      request({
        url: '/basic/basReturnType/getLists',
        method: 'post',
        data: {
          usable: 1,
          orderId: this.formData.id
        },
        isLoading: true,
        modalStrictly: true,
      }).then(response => {
        this.returnData = response.data.data;
      })
    },

    getData() {
      //获取对应的工单信息
      request({
        url: api.soOrder.getDataUrl,
        method: 'post',
        data: {
          id: this.formData.id
        },
        isLoading: true,
        modalStrictly: true,
      }).then(response => {
        if (response.data.data.soOrderExtendDTO.dutyJudge != null) {
          this.formData.dutyJudge = response.data.data.soOrderExtendDTO.dutyJudge;
          this.formData.dutyJudgeSub = response.data.data.soOrderExtendDTO.dutyJudgeSub;
        }
        this.formData.handleModel = response.data.data.soOrderExtendDTO.handleModel;
        this.formData.handlePlan = response.data.data.soOrderExtendDTO.handlePlan;
      })
    },
    getdutyJudgeSub(e) {
      if (e != null) {
        this.formData.dutyJudgeSub = null;
        // this.formData.dutyJudgeSubName = null;
        request({
          url: '/admin/dict/getDictItemByRefDictItemId',
          method: 'post',
          data: {
            refDictItemId: e
          },
          isLoading: true,
          modalStrictly: true,
        }).then(response => {
          this.dutyJudgeSubList = response.data.data;
        })
      }
    },
    commit() {
      let rules = {
        remark: [{ prop: '处理备注', required: true, max: 100 }],
        result: [{ prop: '处理结果', required: true }]
      }

      if (this.formData.result === '转线处理') {
        rules.handleId = [{ prop: '督办人', required: true }]
        rules.handleTime = [{ prop: '督办时间', required: true }]
        rules.handleMatter = [{ prop: '督办事项', required: true }]
      }

      if (this.formData.result === '取消') {
        rules.returnId = [{ prop: '取消原因', required: true }]
        let returnName = this.$refs.returnId.selected.label;
        this.formData.returnName = returnName;
      }

      if (this.formData.result === '结束') {
        rules.dutyJudge = [{ prop: '责任判定', required: true }]
        rules.dutyJudgeSub = [{ prop: '责任细分', required: true }]
        rules.handlePlan = [{ prop: '处理方案', required: true }]
      }



      this.$validate(this.formData, rules).then(res => {
        this.$mask.open()
        this.$http({
          url: api.soOrder.orderComplaintHandlingUrl,
          method: 'post',
          data: this.formData
        }).then(res => {
          this.$mask.close()
          this.$message.success('操作成功')
          this.handleClose()
          this.$emit('goBackIndex')
        }).catch(() => {
          this.$mask.close()
        })
      })
    },


    confirm() {
      this.handleClose()
    },
    cancelForm() {
      this.handleClose()
    },
    handleClose() {
      this.visiable = false
      this.$emit('update:visiable', this.visiable)
    }
  }
}
</script>
<style lang="scss" scoped>
.details2 {

  ::v-deep .el-drawer .el-drawer__body {
    padding: 0 16px;
    background-color: #fff;
    position: relative;
  }

  ::v-deep .el-drawer .el-drawer__header {
    background-color: #fff;
  }

  ::v-deep .el-drawer__container {
    position: relative;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    height: 100%;
    width: 100%;
    background: aliceblue;
    background-color: rgb(38 38 38 / 70%);
  }

  #containt .table-detail {
    border-collapse: collapse;
    font-size: 12px;
    border: 1px solid #ededed;
  }

  .btn {
    text-align: center;
  }

  //   3个标签
  .information {
    padding: 0px 10px;
    background-color: #E1F2FF;
    color: #268AEA;
    border-radius: 3px;
    margin: 0 5px;
    font-size: 15px;
  }

  //   每个分支
  .d-item {
    border: 1px solid #ededed;
    padding-bottom: 5px;

    .title b {
      display: inline-block;
      line-height: 20px;
      font-size: 13px;
      font-weight: 600;
      margin-right: 84px;
      vertical-align: middle;
      color: rgb(42, 100, 148);
      position: relative;
      z-index: 2;
      background: rgba(42, 100, 148, 0.16);
      margin-left: 0px;
      margin-bottom: 8px;
      padding-left: 12px;
      padding-right: 14px;
      border-radius: 0px 28px 28px 0px;
    }

    .table-detail tr {
      margin-bottom: 10px;
      display: block;

      th {
        font-weight: 400;
        text-align: right;
        width: 7vw !important;
        font-size: 12px;
        position: relative;
        padding: 0 5px 0 4px;
        color: rgba(86, 86, 86, 0.96);
      }

      td {
        font-weight: 400;
        // text-align: right;
        width: 10vw !important;
        font-size: 12px;
        position: relative;
        padding: 0 0px 0 4px;
        color: rgba(0, 0, 0, );
      }
    }
  }

  ::v-deep .el-image__preview {
    width: 60px !important;
    height: 60px !important;
  }

  .pic_main {
    display: flex;
    margin-left: 20px;
    margin-top: 10px;

    .pic_item {
      display: flex;
      margin-right: 40px;

      span {
        white-space: nowrap;
        line-height: 60px;
        font-size: 12px;
        color: rgba(86, 86, 86, 0.96);
        font-weight: 400;

      }
    }
  }

  // 本单费用位置
  .expense {
    position: absolute;
    right: 20%;
    margin-top: 5px;
    color: #00c4b3;
    font-size: 13px;
  }

  // 滚动条样式

  /* 滚动条 */
  ::-webkit-scrollbar {
    width: 5px;
    height: 12px;
  }

  /* 滚动槽 */
  ::-webkit-scrollbar-track {
    border-radius: 0px;
    // background: rgba(224, 7, 7, 0.05);
  }

  /* 滚动条滑块 */
  ::-webkit-scrollbar-thumb {
    border-radius: 00px;
    background: #cfcece;
  }

  // 步骤条 圆的位置
  ::v-deep .el-timeline-item__node--normal {
    left: 0px !important;
    width: 12px;
    height: 12px;
  }

  ::v-deep .el-step__title {
    font-size: 13px !important;
    line-height: 38px;
  }
}

::v-deep .el-form-item .el-form-item__label {
  font-size: 12px;
  font-weight: 400;
  width: 100px;
}

::v-deep .el-form-item {
  margin-bottom: 8px !important;
}

.videoAdd {
  width: 40px;
  height: 40px;
  background-color: #fbfdff;
  border: 1px dashed #c0ccda;
  border-radius: 6px;
  font-size: 28px;
  color: #8c939d;
  text-align: center;
  line-height: 40px;

}

.videoP {
  margin-left: 10px;
  margin-bottom: 10px;
  padding: 5px;
  border: 1px solid #e8e8e8;
  width: 150px;
    height: 70px;
  display: flex;
  justify-content: space-between;
  border-radius: 3px;
}

.imgY {
  position: absolute;
  height: 35px;
  width: 35px;
  top: 0;
  background-color: #c6c2c2;
  opacity: 0.9;
  text-align: center;
  line-height: 35px;
  font-size: 30px;
  display: none;
}

.videoImg:hover .imgY {

  display: block
}
</style>
